"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseLanguageSettingsFromPayload = parseLanguageSettingsFromPayload;
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _actions = require("settings-ui-sdk/SiteSettings/actions");

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _handleActions;

function parseLanguageSettingsFromPayload(_ref) {
  var data = _ref.data;

  if (data.bodyOverrideByDomain) {
    return (0, _immutable.fromJS)((0, _extends3.default)((0, _defineProperty2.default)({}, _UrlPathParams.ALL_DOMAINS, data), data.bodyOverrideByDomain));
  }

  return (0, _immutable.fromJS)(data);
}

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchSiteSettingsActionTypes.SUCCESS, function (state, action) {
  return parseLanguageSettingsFromPayload(action.payload);
}), (0, _defineProperty2.default)(_handleActions, _actions.SaveSiteSettingsChangesActionTypes.SUCCESS, function (state, action) {
  return state.merge(parseLanguageSettingsFromPayload(action.payload));
}), _handleActions), (0, _immutable.Map)());

exports.default = _default;